import { Chip } from '@mui/material'
import { TpTooltip } from '~/components'

/**
 * Task status chip with custom colors for each state
 *
 * States:
 * - scheduled: Yellow (not ready yet)
 * - ready: Blue (active work)
 * - overdue: Orange (late)
 * - completed: Green (success)
 * - cancelled: Red (stopped)
 */
export const TaskItemStatusChip = ({ state, stateName }) => {
  const styles = getStateStyles(state)

  const tooltipTitle = state === 'scheduled'
    ? 'Task is not in the ready window yet'
    : ''

  return (
    <TpTooltip title={tooltipTitle}>
      <Chip
        label={stateName}
        size="small"
        sx={{
          height: 20,
          fontSize: '0.75rem',
          fontWeight: 500,
          ...styles
        }}
      />
    </TpTooltip>
  )
}

/**
 * Get background and text colors for each task state
 */
const getStateStyles = (state) => {
  switch (state) {
    case 'scheduled':
      return {
        bgcolor: '#FFD600',       // Yellow background
        color: '#424242',         // Dark gray text for contrast
        '&:hover': {
          bgcolor: '#FFB300'      // Darker yellow on hover
        }
      }

    case 'ready':
      return {
        bgcolor: '#1976D2',       // Blue background
        color: '#FFFFFF',         // White text
        '&:hover': {
          bgcolor: '#1565C0'
        }
      }

    case 'overdue':
      return {
        bgcolor: '#D32F2F',       // Red background
        color: '#FFFFFF',         // White text
        '&:hover': {
          bgcolor: '#C62828'
        }
      }
      
    case 'completed':
      return {
        bgcolor: '#2E7D32',       // Green background
        color: '#FFFFFF',         // White text
        '&:hover': {
          bgcolor: '#1B5E20'
        }
      }

    case 'cancelled':
      return {
        bgcolor: '#9E9E9E',       // Grey background
        color: '#FFFFFF',         // White text
        '&:hover': {
          bgcolor: '#757575'      // Darker grey on hover
        }
      }

    default:
      return {
        bgcolor: '#1976D2',       // Default to ready style
        color: '#FFFFFF'
      }
  }
}
